export interface CheckboxAnswerOptionIdentity {
  choiceRefId: string;
  id: string;
  optionText: string;
}

/**
 * Checkbox nodes are keyed by `choiceRefId`, while the variable panel and the GraphQL API work
 * in `AnswerOption` row ids. These translate between the two at that boundary.
 */
export function getCheckboxOptionIdentities(
  answerOptions: CheckboxAnswerOptionIdentity[]
): { id: string; legacyId: string; optionText: string }[] {
  return answerOptions.map(option => ({
    id: option.choiceRefId,
    legacyId: option.id,
    optionText: option.optionText,
  }));
}

export function toCheckboxChoiceRefIds(
  selectedAnswerIds: string[],
  answerOptions: CheckboxAnswerOptionIdentity[]
): string[] {
  const choiceRefIdByRowId = new Map(answerOptions.map(option => [option.id, option.choiceRefId]));

  return selectedAnswerIds.flatMap(rowId => {
    const choiceRefId = choiceRefIdByRowId.get(rowId);
    return choiceRefId ? [choiceRefId] : [];
  });
}
